class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('.search-bar-wrapper form');

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');

    this.abortController = new AbortController();

    // prevent empty submit
    this.form.addEventListener('submit', (event) => {
      const searchTerm = this.getQuery();
      if (!searchTerm.length) {
        event.preventDefault();
        event.stopPropagation();
        return false;
      }
    });

    this.input.addEventListener(
      'input',
      this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this)
    );

     // reopen on input focus
    this.input.addEventListener('focus', () => {
      const searchTerm = this.getQuery();
      if (!searchTerm.length) return;
      if (this.predictiveSearchResults.innerHTML.trim() !== '') {
        this.open();
      } else {
        this.getSearchResults(searchTerm);
      }
    });

    // close on outside click
    document.addEventListener('click', (event) => {
      if (!this.contains(event.target)) {
        this.close();
      }
    });
  }

  debounce(fn, wait) {
    let t;

    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {

    // cancel previous request
    this.abortController.abort();

    // new controller
    this.abortController = new AbortController();

    fetch(
      `${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`,
      {
        signal: this.abortController.signal,
      }
    )
      .then((response) => response.text())
      .then((text) => {

        const html = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search');

        if (!html) return;

        this.predictiveSearchResults.innerHTML = html.innerHTML;

        this.open();
      })
      .catch((e) => {

        if (e.name === 'AbortError') return;

        console.error(e);
      });
  }

  open() {
    this.setAttribute('open', true);
  }

  close() {
    this.removeAttribute('open');
    this.predictiveSearchResults.innerHTML = '';
  }
}

customElements.define('predictive-search', PredictiveSearch);